import React, { useEffect, useMemo, useState } from 'react';

import { useSelector } from 'react-redux';
import { textSort } from '../../helpers/textSort';
import PropTypes from 'prop-types';
import { cloneDeep } from 'lodash';
import { v4 as uuidv4 } from 'uuid';

import { Button, Col, Row } from 'antd';
import CustomInputNumber from '../../components/CustomInputNumber/CustomInputNumber';
import CustomSelect from '../../components/CustomSelect/CustomSelect';
import { ReactComponent as Pluse } from '../../assets/pluse-black-icon.svg';
import { ReactComponent as Delete } from '../../assets/delete-black-icon.svg';

const WeightRangeVolatilityAdjustment = ({
  t,
  storedPrimitives,
  setStoredPrimitives,
  hendleChangeValue,
  validate,
}) => {
  const {assets, assetCategories, diversificationList} = useSelector((state) => state.instrumentsReducer);
  const [primitivesSet, setPrimitivesSet] = useState(null);

  const renderSelectOption = useMemo(() => {
    const renderAssets = assets
    ?.filter((i) => !i.is_virtual)
    ?.map((el) => {
      const isSelected = primitivesSet?.some(
        (i) => i.asset_class_1_id === el.ID,
      );
      return {
        key: el.ID,
        value: el?.ID,
        label: el?.name,
        disabled: isSelected,
      };
    });
    const renderCategory = assetCategories
    ?.map((el) => {
      const isSelected = primitivesSet?.some(
        (i) => i.asset_class_1_id === el.ID,
      );
      return {
        key: el.ID,
        value: el?.ID,
        label: el?.name,
        disabled: isSelected,
      };
    });
    const renderDiver = diversificationList
    ?.map((el) => {
      const isSelected = primitivesSet?.some(
        (i) => i.asset_class_1_id === el.id,
      );
      return {
        key: el.id,
        value: el?.id,
        label: el?.name,
        disabled: isSelected,
      };
    });
    return (
      [
        {
          label: <span>{t('ASSET_CLASS')}</span>,
          title: 'assetClass',
          options: renderAssets.sort((a, b) => textSort(a.label, b.label)),
        },
        {
          label: <span>{t('ASSET_CATEGORY')}</span>,
          title: 'assetCategory',
          options: renderCategory.sort((a, b) => textSort(a.label, b.label)),
        },
        {
          label: <span>{t('DIVERSIFICATION')}</span>,
          title: 'diversification',
          options: renderDiver.sort((a, b) => textSort(a.label, b.label)),
        },
      ]
  );
  }, [assets, assetCategories, diversificationList, primitivesSet, storedPrimitives]);
  
  // const [searchAsset, setSearchAsset] = useState(null);
  // const [filteredAsset, setFilteredAsset] = useState(renderSelectOption);


  useEffect(() => {
    if (storedPrimitives) {
      const data = storedPrimitives?.filter((i) => i.entity === 61);
      if (!data?.length) {
        setPrimitivesSet([]);
        return;
      }
    //   setPrimitivesSet(
    //     data?.sort((a, b) => {
    //       const nameA = getAssetById(a.asset_class_1_id)?.name || '';
    //       const nameB = getAssetById(b.asset_class_1_id)?.name || '';
    //       if (!nameA && nameB) return 1;
    //       if (nameA && !nameB) return -1;
    //       if (!nameA && !nameB) return 0;
    //       return textSort(nameA, nameB);
    //     }),
    //   );
    // }
      setPrimitivesSet(data);
    }
  }, [storedPrimitives]);

  useEffect(() => {
    if (primitivesSet?.length) {
      validate(
        primitivesSet.every(
          (i) =>
            (i.value || i.value === 0) &&
            (i.p1 || i.p1 === 0) &&
            (i.p2 || i.p2 === 0),
        ),
        'weightRange',
      );
    } else {
      validate(true, 'weightRange');
    }
  }, [primitivesSet]);

  const getAssetById = (id) => {
    const asset = assets.find((asset) => asset.ID === id);
    if(asset) {
      return {
        name: asset?.name ?? '',
        category: asset?.financialAssetCategory.name ?? '',
      };
    }
    const cateegory = assetCategories.find((asset) => asset.ID === id);
    if(cateegory) {
      return {
        name: cateegory?.name ?? '',
        category: '',
      };
    } 
    const iversification = diversificationList.find((asset) => asset.id === id);
    if(iversification) {
      return {
        name: iversification?.name ?? '',
        category: '',
      };
    } 
  };

  const filterOption = (input, option) => {
    const label = option?.label;
    if (typeof label === 'string') {
      return label.toLowerCase().includes(input.toLowerCase());
    }
  
    return false;
  };

  const handleSelect = (value, id) => {
    const clonData = cloneDeep(storedPrimitives);
    const updated = clonData.map((i) => {
      if (i.asset_class_1_id === id) {
        const el = { ...i, asset_class_1_id: value };
        return el;
      } else {
        return i;
      }
    });
    setStoredPrimitives(updated);
  };

  const handleDelete = (asset_id, id) => {
    const clonData = cloneDeep(storedPrimitives);
    if(id) {
      const newData = clonData.filter((i) => !(i.entity === 61 && i.id === id));
      setStoredPrimitives(newData);
    } else {
      const newData = clonData.filter((i) => !(i.entity === 61 && i.asset_class_1_id === asset_id));
      setStoredPrimitives(newData);
    }
  };  

  const addWeightRange = () => {
    setStoredPrimitives([
      ...storedPrimitives,
      {
        entity: 61,
        value: null,
        p1: null,
        p2: null,
        asset_class_1_id: uuidv4(),
      },
    ]);
  };

  const handleClearAll = () => {
    const clonData = cloneDeep(storedPrimitives);
    const newData = clonData.map((i) => {
      if (i.entity === 61) {
        const el = { ...i, value: null, p1: null, p2: null };
        return el;
      } else {
        return i;
      }
    });
    setStoredPrimitives(newData);
  };

  return (
    <>
      <Row wrap={false} className="primitives-header">
        <Col span={6} className="primitives-title-class contrast">
          {t('ASSET_CLASS')}
        </Col>
        <Col span={5} className="primitives-title-value">
          {t('p1')}
        </Col>
        <Col span={5} className="primitives-title-value">
          {t('p2')}
        </Col>
        <Col span={5} className="primitives-title-value">
          {t('VALUE')}
        </Col>
        <Col span={3} className="asset-class-title-allocation">
          <Button
            className="portfolio-details-btn primitives-clear-btn"
            onClick={handleClearAll}
          >
            {t('CLEAR_ALL')}
          </Button>
        </Col>
      </Row>
      {primitivesSet &&
        primitivesSet?.map((el) => {
          return (
            <Row
              key={el.asset_class_1_id}
              wrap={false}
              className={'primitives-row'}
            >
              <Col span={6} className="">
                {typeof el.asset_class_1_id !== 'string' ? (
                  <div className="">
                    <p className="primitives-cell-name">
                      {getAssetById(el.asset_class_1_id)?.name}
                    </p>
                    <p className="primitives-cell-category">
                      {getAssetById(el.asset_class_1_id)?.category}
                    </p>
                  </div>
                ) : (
                  <CustomSelect
                    animate={false}
                    showSearch
                    width="100%"
                    className="custom-select input-search"
                    value={typeof el.asset_class_1_id !== 'string' ? el.asset_class_1_id : ''}
                    onSelect={(value) =>
                      handleSelect(value, el?.asset_class_1_id)
                    }
                    options={renderSelectOption}
                    placeholder={t('')}
                    filterOption={filterOption}
                  />
                )}
              </Col>
              <Col span={5} className="primitives-title-value">
                <div className="">
                  <CustomInputNumber
                    width={'132px'}
                    value={el?.p1 ? (el?.p1 * 100).toFixed(2) : ''}
                    percent
                    precision={2}
                    min={0}
                    onBlur={(e) =>
                      hendleChangeValue(
                        null,
                        e.target.value,
                        el?.asset_class_1_id,
                        'p1',
                      )
                    }
                    className="custom-inputnumber model-series"
                    controls={false}
                  />
                </div>
              </Col>
              <Col span={5} className="primitives-title-value">
                <div className="">
                  <CustomInputNumber
                    width={'132px'}
                    value={el?.p2 ? (el?.p2 * 100).toFixed(2) : ''}
                    percent
                    precision={2}
                    min={0}
                    onBlur={(e) =>
                      hendleChangeValue(
                        null,
                        e.target.value,
                        el?.asset_class_1_id,
                        'p2',
                      )
                    }
                    className="custom-inputnumber model-series"
                    controls={false}
                  />
                </div>
              </Col>
              <Col span={5} className="primitives-title-value">
                <div className="">
                  <CustomInputNumber
                    width={'132px'}
                    value={el?.value ? (el?.value * 100).toFixed(2) : ''}
                    percent
                    precision={2}
                    min={0}
                    onBlur={(e) =>
                      hendleChangeValue(
                        null,
                        e.target.value,
                        el?.asset_class_1_id,
                        'value',
                      )
                    }
                    className="custom-inputnumber model-series"
                    controls={false}
                  />
                </div>
              </Col>
              <Col span={3} className="asset-class-title-allocation">
                <div
                  style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <Button
                    type='text'
                    className='operation'
                    style={{ marginTop: '5px', cursor: 'pointer' }}
                    icon={<Delete />}
                    onClick={() => handleDelete(el?.asset_class_1_id, el?.id)}
                  />
                </div>
              </Col>
            </Row>
          );
        })}
      <Row justify={'end'} style={{padding: '24px'}}>
        <Button
          type="text"
          className="holdings-add-btn add-instrument"
          onClick={() => addWeightRange()}
          icon={<Pluse />}
          iconPosition={'end'}
        >
          {t('ADD')}
        </Button>
      </Row>
    </>
  );
};

export default WeightRangeVolatilityAdjustment;

WeightRangeVolatilityAdjustment.propTypes = {
  t: PropTypes.func.isRequired,
  storedPrimitives: PropTypes.array,
  setStoredPrimitives: PropTypes.func.isRequired,
  hendleChangeValue: PropTypes.func.isRequired,
  validate: PropTypes.func.isRequired,
};
